export default {
  topCenterContentBlock: state => state.topCenterContentBlock
};
